import React from "react";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";

const container = document.getElementById('root');
const root = createRoot(container!)
root.render(<App />);
serviceWorker.unregister();